import { ArrowRight } from "lucide-react";
import { Reveal } from "../landing/shared";

export const EmployerFinalCTA = () => (
    <section
        data-testid="employer-final-cta"
        className="bg-forest-deep py-24 text-center text-ivory lg:py-32"
    >
        <div className="mx-auto max-w-4xl px-6">
            <Reveal>
                <span className="inline-flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.3em] text-ivory/60">
                    <span className="h-px w-8 bg-champagne" aria-hidden="true" />
                    Begin the Conversation
                    <span className="h-px w-8 bg-champagne" aria-hidden="true" />
                </span>
                <h2 className="mt-6 font-serif text-3xl font-medium tracking-tight sm:text-4xl lg:text-5xl">
                    Ready to Build Your International Workforce?
                </h2>
                <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-ivory/70">
                    Tell us what your organization needs and begin a conversation with Afrinexa Global.
                </p>
                <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
                    <a
                        href="#employer-form"
                        data-testid="employer-final-submit-btn"
                        className="inline-flex items-center justify-center gap-2 whitespace-nowrap bg-champagne px-8 py-4 text-sm font-semibold uppercase tracking-[0.1em] text-ink transition-colors duration-300 hover:bg-ivory"
                    >
                        Submit Recruitment Request
                        <ArrowRight size={16} strokeWidth={1.5} />
                    </a>
                    <a
                        href="#direct-contact"
                        data-testid="employer-final-contact-btn"
                        className="inline-flex items-center justify-center border border-ivory/30 px-8 py-4 text-sm font-semibold uppercase tracking-[0.1em] text-ivory transition-colors duration-300 hover:border-ivory hover:bg-ivory/10"
                    >
                        Contact Afrinexa
                    </a>
                </div>
            </Reveal>
        </div>
    </section>
);
